import styled from '@emotion/styled';
import { getHoursArray, getRulerDividerLeftOffset, getLabelXValue } from './overviewUtils';

const Container = styled.div`
  width: 100%;
  position: relative;
  background-color: #8b92a3;
  margin-top: 6px;
  height: 1px;
  max-width: 1000px;
`;

const RulerItem = styled.div`
  position: absolute;
  top: 0;
  left: 0;
`;

const DividerLine = styled.div`
  width: 1px;
  background-color: #8b92a3;
  height: 15px;
`;

const Label = styled.span`
  color: #9197a7;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  display: block;
  min-width: 36px;
`;

export const BarGraphRuler = () => {
  const hrsArray = getHoursArray();

  return (
    <Container>
      {hrsArray.map((hr) => (
        <RulerItem
          key={hr}
          style={{
            left: getRulerDividerLeftOffset(hr),
          }}
        >
          <DividerLine />
          <Label style={{ transform: `translate(${getLabelXValue(hr)}, 4px)` }}>{hr} hrs</Label>
        </RulerItem>
      ))}
    </Container>
  );
};
